// extracted by mini-css-extract-plugin
export default {"footer":"Layout_footer__2C6kk","container":"Layout_container__cBokR","content_container":"Layout_content_container__Mq+LM","content":"Layout_content__kOYES"};